import { Header } from "./Header/Header";
import { LocationSearchBar } from "./LocationSearch/LocationSearchBar";

export const Mod = {
  Header,
  LocationSearchBar,
};
